import styled from 'styled-components';

export const Input = styled.input`
  background-color: var(--ui-surface);
  color: var(--text-primary);
  border: 1px solid var(--ui-border);
  border-radius: var(--border-radius-small);
  padding: var(--space-2);
  font-size: var(--font-size-body);
  font-family: var(--font-family-primary);
  width: 100%;
  min-height: 40px;

  &:focus {
    border-color: var(--ui-focus);
    outline: none;
  }

  &:disabled {
    background-color: var(--ui-disabled);
    color: var(--text-muted);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--text-neutral);
  }
`;

export const TextArea = styled.textarea`
  background-color: var(--ui-surface);
  color: var(--text-primary);
  border: 1px solid var(--ui-border);
  border-radius: var(--border-radius-small);
  padding: var(--space-2);
  font-size: var(--font-size-body);
  font-family: var(--font-family-primary);
  width: 100%;
  min-height: 80px;
  resize: vertical;

  &:focus {
    border-color: var(--ui-focus);
    outline: none;
  }

  &:disabled {
    background-color: var(--ui-disabled);
    color: var(--text-muted);
    cursor: not-allowed;
  }

  &::placeholder {
    color: var(--text-neutral);
  }
`;

export const Select = styled.select`
  background-color: var(--ui-surface);
  color: var(--text-primary);
  border: 1px solid var(--ui-border);
  border-radius: var(--border-radius-small);
  padding: var(--space-2);
  font-size: var(--font-size-body);
  font-family: var(--font-family-primary);
  width: 100%;
  min-height: 40px;
  cursor: pointer;

  &:focus {
    border-color: var(--brand-primary);
    outline: none;
  }

  &:disabled {
    background-color: var(--ui-disabled);
    color: var(--text-muted);
    cursor: not-allowed;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 20px;
  height: 20px;
  border-radius: var(--border-radius-small);
  border: 2px solid var(--border-muted);
  background-color: var(--ui-surface);
  cursor: pointer;
  margin: 0;
  appearance: none;
  position: relative;

  &:checked {
    background-color: var(--brand-primary);
    border-color: var(--brand-primary);
  }

  &:checked::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--text-inverse);
    font-size: 12px;
    font-weight: bold;
  }

  &:hover {
    border-color: var(--brand-primary);
  }

  &:disabled {
    background-color: var(--ui-disabled);
    border-color: var(--ui-disabled);
    cursor: not-allowed;
  }
`;

export const CheckboxLabel = styled.label`
  font-size: 13px;
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: var(--space-3);
  cursor: pointer;
  user-select: none;

  &:has(input:disabled) {
    color: var(--text-muted);
    cursor: not-allowed;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-bottom: var(--space-3);
`;

export const FormLabel = styled.label`
  font-size: var(--font-size-label);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-bottom: var(--space-1);
`;

export const FormError = styled.div`
  font-size: var(--font-size-fine);
  color: var(--state-error);
  margin-top: var(--space-1);
`;

export const FormHelp = styled.div`
  font-size: var(--font-size-fine);
  color: var(--text-secondary);
  margin-top: var(--space-1);
`;

